import observer from 'saddlebag-observer';

import getFeatureDecision from '../../../../config';
import { ENABLE_PAGE_LOAD_DIAGNOSTIC } from '../../../../config/constants';
import { TRACKING } from '../../../../constants';

const GRAPPLER_EVENT = 'grappler-track';

const DISCARDED_STATE = {
  UNSET: 'UNSET_DISCARDED_STATE',
  TRUE: 'DISCARDED_STATE_TRUE',
  FALSE: 'DISCARDED_STATE_FALSE',
} as const;

type DiscardedState = (typeof DISCARDED_STATE)[keyof typeof DISCARDED_STATE];

const getDiscardedState = (): DiscardedState => {
  const { wasDiscarded } = document as Document & { wasDiscarded?: boolean };
  if (wasDiscarded === undefined) {
    return DISCARDED_STATE.UNSET;
  }
  return wasDiscarded ? DISCARDED_STATE.TRUE : DISCARDED_STATE.FALSE;
};

const getNavigationType = (): string => {
  try {
    const entries = performance.getEntriesByType('navigation');
    if (entries.length > 0) {
      return (entries[0] as PerformanceNavigationTiming).type;
    }
  } catch {
    // empty
  }
  return 'unknown';
};

export const trackPageLoadDiagnostic = (viewId: string) => {
  if (!getFeatureDecision(ENABLE_PAGE_LOAD_DIAGNOSTIC, false)) {
    return;
  }

  observer.publish(GRAPPLER_EVENT, {
    isMiniEvent: true,
    consentRequired: false,
    eventName: TRACKING.MESSAGES.PAGE_LOAD_DIAGNOSTIC,
    fullSchemaName: TRACKING.SCHEMAS.PAGE_LOAD_DIAGNOSTIC_SCHEMA,
    message: {
      navigation_type: getNavigationType(),
      visibility_at_load: document.visibilityState,
      page_group: 'month-view',
      view_id: viewId,
      discarded_state: getDiscardedState(),
    },
  });
};
